module.exports = __webpack_public_path__ + "img/mission.2d740174.jpg";